<script lang="ts">
  import { onMount, tick, afterUpdate } from "svelte";
  import Map from "./Map.svelte";
  import MapIcon from "./MapIcon.svelte";
  import Pane from "./Pane.svelte";
  import Index from "./Index.svelte";
  import UniversalAccess from "./UniversalAccess.svelte";
  import content from "./content.js";
  import router from "page";
  import Section from "./Section.svelte";
  import CloseIcon from "./Close.svelte";

  let p = true;
  let showArt = false;
  let showTitle = true;
  export let name: string;

  let showSources = false;
  let showMap = false;
  let showMenu = false;
  let prefix = "/lassen/";

  let showPlayer = false;

  function toggleSources(e){
    showSources = e.detail;
  }

  function toggleTitle(e) {
    showTitle = e.detail.value;
  }

  let currentAudio = false;
  let currentIndex = 0;

  let i = 0;

  function preload(src) {
    return new Promise(function (resolve) {
      let img = new Image();
      img.onload = resolve;
    });
  }

  let y;
  let universalMode = false;

  let path = "";

  router("*", (ctx) => {
    path = ctx.path;
  });

  $: if(path=='map'){
    showMap=true;
  }

  router.start();

  // window.onscroll = function(){
  //     document.getElementsByTagName('html')[0].classList.add('snap');
  //     window.onscroll = null;
  // }

  let scrollbar;

  onMount(async () => {
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    path = path.replace(/\/$/, "");
    path = path.substring(path.lastIndexOf("/") + 1);

    $: i =
      content.findIndex((el) => el.slug == path) == -1
        ? 0
        : content.findIndex((el) => el.slug == path);
    let el = document.getElementById(path);

    if (path && path != "lassen" && i && el) {
      await tick();
      document.getElementById("container").scrollTo(0, el.offsetTop);
      // await tick();
      // document.getElementsByTagName('html')[0].classList.add('snap');
    }

    $: {
      scrollbar = main.scrollWidth < window.innerWidth;
    }
  });

  const toggleUniversalMode = () => (universalMode = !universalMode);

  $: bg = !universalMode && content && content[i] ? content[i].bg : "white";
  $: fg = !universalMode && content && content[i] ? content[i].fg : "black";
  $: shadow =
    !universalMode && content && content[i] ? content[i].shadow : "black";

  $: cond = i;

  let player;

  function changeColors(e) {
    if (!universalMode) {
      fg = e.detail.fg;
      bg = e.detail.bg;
      shadow = e.detail.shadow;
    }
  }

  let h;
  let main;
</script>

<svelte:window bind:scrollY={y} bind:innerHeight={h} />

<div id="container" bind:this={main} style="--scrollbar:{scrollbar ? 15 : 0}px">
  {#each content as data, j}
    <Section
      {data}
      on:enter={changeColors}
      i={j}
      {h}
      bind:currentAudio
      bind:p
      bind:universalMode
      bind:currentIndex
      on:sources={toggleSources}
    />
  {/each}

  <!-- <AudioPlayerGlobal {fg} {bg} {shadow} bind:this={player} bind:src={currentAudio}  bind:showPlayer bind:paused /> -->

  <!-- <AudioControls bind:currentAudio bind:p {h} bind:bg bind:fg bind:currentData /> -->

{#if !showMenu && !showSources}
    <button on:click={() => (showMap = !showMap)} id="map-trigger">
    {#if !showMap}
      <MapIcon bind:fg />
    {:else}
     <span class="close"> &times;</span>
    {/if}
  </button>
{/if}

  <Pane bind:showPane={showMap}>
    <Map bind:fg bind:bg/>
  </Pane>

  <button class="ua" on:click={toggleUniversalMode}>
    <UniversalAccess bind:universalMode bind:bg bind:fg {shadow} />
  </button>

  {#if showTitle}
    <header class="index">
      <Index data={content} bind:open={showMenu} bind:i bind:fg bind:bg bind:universalMode {shadow} {scrollbar} />
    </header>
  {/if}
</div>



<style>
  header {
    position: fixed;
    top: 0;
    left: 3rem;
    right: 3rem;
    z-index: 50;
  }

  section {
    min-height: 100vh;
  }

  main > * > * {
    left: 0;
  }

  #map-trigger {
    position: fixed;
    right: 1rem;
    top: 0.5rem;
    z-index: 200;
  }

  #container {
    -ms-scroll-snap-type: mandatory;
    scroll-snap-type: mandatory;
    -ms-scroll-snap-points-y: repeat(100vh);
    scroll-snap-points-y: repeat(100vh);
    -ms-scroll-snap-type: y mandatory;
    scroll-snap-type: y mandatory;
    -webkit-overflow-scrolling: touch;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    position: fixed;
    top: 0;
    left: 0;
    scrollbar-width: none;
  }

  #container::-webkit-scrollbar {
    /* display: none; */
  }

  .ua {
    position: fixed;
    top: 1rem;
    left: 1rem;
    z-index:5;
    opacity: 1;
    padding:0;
  }

  span.close{
    font-size:1.4rem;
    color:black;
  }
</style>
